import { render, staticRenderFns } from "./cardcash.vue?vue&type=template&id=8d48870e&scoped=true&"
import script from "./cardcash.vue?vue&type=script&lang=js&"
export * from "./cardcash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d48870e",
  null
  
)

export default component.exports